import {Record, useDataProvider, useNotify, useRedirect} from "react-admin";
import {useHistory} from "react-router-dom";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {Button, Modal} from "antd";
import React from "react";
import type {SizeType} from "antd/es/config-provider/SizeContext";

const { confirm } = Modal;


const DeleteButton = ({ title, resource, record, style = {}, size, refetch, redirectTo }: { title: string, resource: string, record: Record, style?: React.CSSProperties, size?: SizeType, refetch?: () => void, redirectTo?: string },) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    // where a deletion leaves you, for a record whose list is not at /<resource>
    // — a tab on another page, say. A query string has to go through the router
    // itself: react-admin's redirect would push it as part of the path.
    const history = useHistory();
    const redirect = useRedirect();
    const handleClick = () => {
        confirm({
            icon: <ExclamationCircleOutlined />,
            content: `Are you sure you want to delete the ${title}?`,
            onOk() {
                return dataProvider.delete(resource, { id: record.id })
                    .then(response => {
                        notify(`${title} deleted`)
                        if(refetch){
                            refetch()
                            return
                        }
                        if(redirectTo){
                            history.push(redirectTo)
                            return
                        }
                        redirect(`/${resource}`)
                    }).catch(error => {
                        notify("Something went wrong", "warning")
                    })
            },
        });
    };
    return <Button size={size} style={style} danger onClick={handleClick}>Delete</Button>;
};


export default DeleteButton;
